<template lang="html">
  <div class="col-12 col-xl-10 offset-xl-1 col-tab-2">
    <h5 class="tab-title">Preguntas frecuentes</h5>

    <h5 class="subtitle">Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5 class="subtitle">Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5 class="subtitle">Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5 class="subtitle">Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5 class="subtitle">Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>

    <br />
    <h5 class="subtitle">Aquí va una pregunta de la sección portabilidad.</h5>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud in anim id est laborum adipisicing elit, sed do eiusmod tempor incididunt ut labore et.
    </p>
  </div>
</template>

<script>
export default {
}
</script>
